import { useToast as useToastOriginal, toast as toastOriginal } from "@/hooks/use-toast";
import { supabase } from '@/integrations/supabase/client';

// Re-export the original hook
export { useToastOriginal as useToast };

// Extended toast function that persists to DB (notification panel event is handled by use-toast.ts)
export const toast = (props: Parameters<typeof toastOriginal>[0]) => {
  const result = toastOriginal(props);
  
  // Skip DB persistence for transient connection toasts
  if ((props as any).skipPersist) return result;
  
  // Persist to database with role targeting
  (async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user) return;
      
      const shopId = localStorage.getItem('activeShopId');
      if (!shopId) return;
      
      // Get user's role and tech ID
      const { data: membership } = await supabase
        .from('memberships')
        .select('role')
        .eq('user_id', session.user.id)
        .eq('shop_id', shopId)
        .eq('status', 'active')
        .maybeSingle();
      
      if (!membership) return;
      
      // Determine target roles based on originator's role
      let targetRoles: string[] = [];
      let targetTechId: string | null = null;
      
      const userRole = membership.role;
      
      if (userRole === 'MANAGER') {
        targetRoles = ['MANAGER'];
      } else if (userRole === 'SERVICE_WRITER') {
        targetRoles = ['MANAGER', 'SERVICE_WRITER'];
      } else if (userRole === 'TECHNICIAN') {
        targetRoles = ['MANAGER', 'SERVICE_WRITER'];
        
        const { data: techUser } = await supabase
          .from('technician_users')
          .select('technician_id')
          .eq('user_id', session.user.id)
          .eq('shop_id', shopId)
          .maybeSingle();
        
        if (techUser) {
          targetTechId = techUser.technician_id;
        }
      }
      
      // Insert notification
      await supabase
        .from('notifications')
        .insert([{
          shop_id: shopId,
          user_id: session.user.id,
          type: props.variant === 'destructive' ? 'error' : (props.variant || 'info'),
          title: String(props.title || 'Notification'),
          message: String(props.description || ''),
          data: (props as any).data || {},
          target_roles: targetRoles,
          target_tech_id: targetTechId,
        }]);
        
    } catch (error) {
      console.warn('Failed to persist notification:', error);
    }
  })();
  
  return result;
};
